<template>
    <div>
        <slot></slot>
    </div>
</template>
<script>
export default {
    mounted() {
        // if(window.innerWidth > 480) {
        //     $('#sidebarSupportedContent').collapse('show')
        // }

        // $('#sidebarSupportedContent').on('hidden.bs.collapse', function () {
        //     $('#content').addClass('content-withou-left');
        // })

        // $('#sidebarSupportedContent').on('show.bs.collapse', function () {
        //     $('#content').removeClass('content-withou-left');
        // })
    },
}
</script>

<style>

</style>
